









import { Component, Vue, Prop } from 'vue-property-decorator'
import { RESPONSE_PAUSE_CODE } from '../store/enums'
import LittleEllipsis from './LittleEllipsis.vue'

@Component({
  props: ['line', 'isLoading'],
  components: {
    LittleEllipsis,
  },
  data() {
    return { readLine: 0 }
  },
  mounted() {
    if ((this as any).line.code === RESPONSE_PAUSE_CODE.DIALOGUE) { (this as any).addCharacter() }
  },
  methods: {
    addCharacter() {
      if ((this as any).readLine == (this as any).content.length) { return }
      if (!(this as any).isLoading) { (this as any).readLine = (this as any).content.length; return}
      (this as any).readLine += 1
      setTimeout(() => { (this as any).addCharacter() }, Math.round(1000 / (this as any).content.length))
    },
  },
  computed: {
    appliedColor() {
      if ((this as any).line.code == RESPONSE_PAUSE_CODE.VOCAB_GET) { return "slc-yellow" }
      else if ((this as any).speaker == "@SYSTEM") { return "slc-blue" }
      return ""
    },
    finalLine() {
      return (this as any).line.code === RESPONSE_PAUSE_CODE.DIALOGUE ?
        (this as any).content.substring(0, (this as any).readLine) : (this as any).content
    },
    isCompleted() {
      return (this as any).readLine == (this as any).content.length
    },
    speaker() {
      switch ((this as any).line.code) {
        case RESPONSE_PAUSE_CODE.DIALOGUE:
          return (this as any).line.body[0]
        case RESPONSE_PAUSE_CODE.SCRIPT_LOAD:
        case RESPONSE_PAUSE_CODE.ERR_UNKNOWN_MACRO:
        case RESPONSE_PAUSE_CODE.ERR_MISSING_SCRIPT:
          return 'SYSTEM'
        case RESPONSE_PAUSE_CODE.EMPTY_LINE:
          return '(EMPTY LINE)'
        default:
          return null
      }
    },
    content() {
      switch ((this as any).line.code) {
        case RESPONSE_PAUSE_CODE.DIALOGUE:
          return (this as any).line.body[1]
        case RESPONSE_PAUSE_CODE.SCRIPT_LOAD:
          return `Loaded script: ${(this as any).line.body.name} (${(this as any).line.body.content.length} lines)`
        case RESPONSE_PAUSE_CODE.VOCAB_GET:
          return `You collected a vocabulary star! Star #${(this as any).line.body.id}: ${(this as any).line.body.term}!`
        case RESPONSE_PAUSE_CODE.ERR_UNKNOWN_MACRO:
        case RESPONSE_PAUSE_CODE.ERR_MISSING_SCRIPT:
          return 'Error: ' + (this as any).line.body
        case RESPONSE_PAUSE_CODE.EMPTY_LINE:
        default:
          return null
      }
    },
  },
})
export default class ScriptLine extends Vue {
}
